import React from 'react';

function SvgAnimatedIconArrowUpRight(props: React.SVGProps<SVGSVGElement>) {
  const iconUuid = React.useId();

  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" {...props}>
      <defs>
        <linearGradient
          id={`${iconUuid}_a`}
          x1={77.92}
          y1={73.43}
          x2={26.25}
          y2={21.75}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#ec6508" />
          <stop offset="1" stopColor="#f3921c" />
        </linearGradient>
        <style>
          {`
            .animate:hover .up-right-line {
              backface-visibility: hidden;
              transform: translateZ(0);
              animation: up-right-line-spin 1500ms linear;
            }

            @keyframes up-right-line-spin {
              0% {
                transform: translateZ(0);
              }

              15% {
                transform: translate(0);
                opacity: 1;
              }

              50% {
                transform: translateX(200px) translateY(-200px);
                opacity: 0;
              }

              60% {
                transform: translateX(-200px) translateY(200px);
                opacity: 0;
              }

              100% {
                transform: translateX(0) translateY(0);
                opacity: 1;
              }
            }

            @media (prefers-reduced-motion: reduce) {
                .up-right-line {
                    animation: none;
                }
            }`}
        </style>
      </defs>
      <g className="up-right-line">
        <path
          className="up-right-line-cd1"
          fill={`url(#${iconUuid}_a)`}
          stroke={`url(#${iconUuid}_a)`}
          strokeWidth={6}
          d="M 28.93 19.07 L 80.53 19.15 L 28.93 19.07 Z"
        />
        <path
          className="up-right-line-cd2"
          fill={`url(#${iconUuid}_a)`}
          stroke={`url(#${iconUuid}_a)`}
          strokeWidth={6}
          d="M 80.61 70.74 L 80.53 19.15 L 80.61 70.74 Z"
        />
        <path
          className="up-right-line-cd3"
          fill={`url(#${iconUuid}_a)`}
          stroke={`url(#${iconUuid}_a)`}
          strokeWidth={5}
          d="M 78.853 21.825 L 77.69 20.64 L 22.98 75.36 L 24.04 76.42 L 78.853 21.825 Z"
        />
      </g>
    </svg>
  );
}

export default SvgAnimatedIconArrowUpRight;
